import React from 'react';
import styles from './Footer.less';

const Footer = () => (
  <div className={styles.footer}>
    <p>
      <a href="https://1ketoan.com" target="_blank" rel="noopener noreferrer">1ketoan.com</a> - Giải pháp Kế toán Online  © 2018 <a href="https://dht.com.vn" target="_blank" rel="noopener noreferrer">Công ty CP Công nghệ Đồng Hành</a>
    </p>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.js